import { combineReducers } from 'redux';

import { reducer as FormReducer } from 'redux-form';
import appReducer from './appReducer';
import userReducer from './userReducer';

export default combineReducers({ form: FormReducer, app: appReducer, user: userReducer });



// WEBPACK FOOTER //
// ./src/utils/store/reducer.js